import { ToastMessage } from "./Toast"
import { useState } from 'react';
import { MAX_PDF_FILE_SIZE } from "../../Config"

export function FileUploadButton(props) {
    //toast
    const [showToast, setShowToast] = useState(false);
    const [msgToast, setMsgToast] = useState("");


    function handleChooseFile(event) {
        if(event.target.files[0] == null){
            event.target.value = '';
            console.log("no choose file")
            return
        }
        let fileName = event.target.files[0].name
        let fileSize = event.target.files[0].size
        let fileExt = fileName.split('.').pop()
        console.log("choose file: " + fileName)
        console.log("choose ext: " + fileExt)
        console.log("choose fileSize: " + fileSize)
        if(fileExt.toLowerCase() == "pdf" && Number(fileSize) <= MAX_PDF_FILE_SIZE){
            props.setFileData(event.target.files[0])
            props.setFileExist(true)
        } else if (fileExt.toLowerCase() != "pdf") {
            fadeOutToast("pdf 파일만 업로드 가능합니다.")
            props.removeFile()
        } else if (Number(fileSize) > MAX_PDF_FILE_SIZE){
            fadeOutToast("3MB 이하 파일만 업로드 가능합니다.")
            props.removeFile()
        }
    }

    function fadeOutToast(msg){
        setToastMessage(true, msg)
        setTimeout(function() {
            setToastMessage(false, "")
        }.bind(this), 3000);
    }

    function setToastMessage(show, message){
        setShowToast(show)
        setMsgToast(message)
    }

    return <form style={{marginTop:'20px', marginRight: '0', marginLeft: '0'}}>
                    <div class="container">
                    <div class="row">
                        <label class="form-label">pdf 파일업로드:</label>
                    </div>
                    <div class="row">
                        <input type="file" accept=".pdf" id="chooseFile" onChange={handleChooseFile} style={{width:'500px'}}/>
                        <button class="btn-close" hidden={!props.fileExist} type="button" aria-label='Close' onClick={props.removeFile}></button>
                    </div>
                </div>
                <ToastMessage show={showToast} msg={msgToast} />
            </form>
}

export function ImageFileUploadButton(props) {
    //toast
    const [showToast, setShowToast] = useState(false);
    const [msgToast, setMsgToast] = useState("");


    function handleChooseFile(event) {
        if(event.target.files[0] == null){
            event.target.value = '';
            console.log("no choose file")
            return
        }
        let fileName = event.target.files[0].name
        let fileSize = event.target.files[0].size
        let fileExt = fileName.split('.').pop()
        // console.log("choose file: " + fileName)
        // console.log("choose ext: " + fileExt)
        // console.log("choose fileSize: " + fileSize)
        if(["png", "jpg", "jpeg"].includes(fileExt.toLowerCase()) && Number(fileSize) <= MAX_PDF_FILE_SIZE){
            props.setFileData(event.target.files[0])
            props.setFileExist(true)
        } else if (fileExt.toLowerCase() != ("png" || "jpg" || "jpeg")) {
            fadeOutToast("이미지 파일만 업로드 가능합니다.")
            props.removeFile()
        } else if (Number(fileSize) > MAX_PDF_FILE_SIZE){
            fadeOutToast("3MB 이하 파일만 업로드 가능합니다.")
            props.removeFile()
        }
    }

    function fadeOutToast(msg){
        setToastMessage(true, msg)
        setTimeout(function() {
            setToastMessage(false, "")
        }.bind(this), 3000);
    }

    function setToastMessage(show, message){
        setShowToast(show)
        setMsgToast(message)
    }

    return <form style={{marginTop:'20px', marginRight: '0', marginLeft: '0'}}>
                    <div class="container">
                    <div class="row">
                        <label class="form-label">파일업로드:</label>
                    </div>
                    <div class="row">
                        <input type="file" accept=".png, .jpg, .jpeg" id="chooseFile" onChange={handleChooseFile} style={{width:'auto'}}/>
                        <button class="btn-close" hidden={!props.fileExist} type="button" aria-label='Close' onClick={props.removeFile}></button>
                    </div>
                </div>
                <ToastMessage show={showToast} msg={msgToast} />
            </form>
}